import {  t  } from "@/client/libs/dummy-i18n";
import { CheckCircleIcon, CheckIcon, ShoppingBagIcon, SparkleIcon } from "@phosphor-icons/react";
import { Badge, Button, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@stackmorph/ui";
import { useState } from "react";

import { PurchaseAddonModal } from "@/client/components/purchase-addon-modal";

// Mock data for now - will be replaced with API call
const mockAddons = [
  {
    id: "addon_resume_review",
    name: "Professional Resume Review",
    description: "Get your resume reviewed by industry experts with detailed feedback",
    price: 49.99,
    category: "services",
    popular: true,
    features: [
      "Detailed feedback within 48 hours",
      "Industry-specific suggestions",
      "ATS compatibility check",
      "Grammar and formatting review",
      "Before/after comparison",
    ],
  },
  {
    id: "addon_linkedin",
    name: "LinkedIn Profile Optimization",
    description: "Optimize your LinkedIn profile to attract recruiters",
    price: 39.99,
    category: "services",
    features: [
      "Profile headline optimization",
      "About section rewrite",
      "Skills recommendations",
      "Content strategy guide",
    ],
  },
  {
    id: "addon_cover_letters",
    name: "Cover Letter Template Pack",
    description: "10 professional cover letter templates for different industries",
    price: 19.99,
    category: "templates",
    popular: true,
    features: [
      "10 industry-specific templates",
      "Customization guide",
      "Download in multiple formats",
      "Lifetime access",
    ],
  },
  {
    id: "addon_ats_optimization",
    name: "ATS Optimization Report",
    description: "Comprehensive ATS scan with optimization recommendations",
    price: 29.99,
    category: "services",
    features: [
      "ATS compatibility score",
      "Keyword optimization",
      "Format recommendations",
      "Industry benchmarking",
    ],
  },
  {
    id: "addon_tech_templates",
    name: "Premium Template Pack - Tech",
    description: "5 premium resume templates for software engineers",
    price: 24.99,
    category: "templates",
    features: [
      "5 modern tech-focused designs",
      "Portfolio integration",
      "GitHub/project showcase",
      "Lifetime access",
    ],
  },
];

export const AddonsMarketplace = () => {
  const [selectedAddon, setSelectedAddon] = useState<any>(null);
  const ownedAddonIds: string[] = []; // Will come from API

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold">{t`Add-ons Marketplace`}</h2>
        <p className="text-sm opacity-75">
          {t`Enhance your job search with premium services and templates`}
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {mockAddons.map((addon) => {
          const owned = ownedAddonIds.includes(addon.id);

          return (
            <Card key={addon.id} className="relative flex flex-col overflow-hidden">
              {addon.popular && (
                <div className="absolute right-4 top-4 z-10">
                  <Badge className="gap-1 bg-yellow-500 text-yellow-950">
                    <SparkleIcon size={12} weight="fill" />
                    {t`Popular`}
                  </Badge>
                </div>
              )}

              <CardHeader>
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                  {addon.category === "services" ? (
                    <CheckCircleIcon size={24} className="text-primary" weight="fill" />
                  ) : (
                    <ShoppingBagIcon size={24} className="text-primary" weight="fill" />
                  )}
                </div>
                <CardTitle>{addon.name}</CardTitle>
                <CardDescription>{addon.description}</CardDescription>
              </CardHeader>

              <CardContent className="flex-1">
                <div className="mb-4">
                  <span className="text-3xl font-bold">${addon.price}</span>
                  <span className="ml-2 text-sm text-muted-foreground">{t`one-time`}</span>
                </div>

                <div className="space-y-2">
                  {addon.features.map((feature) => (
                    <div key={feature} className="flex items-start gap-2">
                      <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-green-500" />
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </CardContent>

              <CardFooter>
                {owned ? (
                  <Button disabled className="w-full">
                    <CheckIcon className="mr-2" />
                    {t`Owned`}
                  </Button>
                ) : (
                  <Button
                    className="w-full"
                    onClick={() => {
                      setSelectedAddon(addon);
                    }}
                  >
                    {t`Purchase Now`}
                  </Button>
                )}
              </CardFooter>
            </Card>
          );
        })}
      </div>

      <PurchaseAddonModal
        addon={selectedAddon}
        isOpen={!!selectedAddon}
        onClose={() => {
          setSelectedAddon(null);
        }}
      />
    </div>
  );
};
